module.exports = __webpack_public_path__ + "media/images/smart_phone/order_menu_mypage/btn_my-page02-4e2259e380ed86db833f27335d2baddd.png";